import { useEffect, useState } from 'react';
export const useLoginStatus = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const getIsLoggedIn = () => {
        const { isLoggedIn: authLoggedIn } = window.cb.core.iam.getAuthSession();
        setIsLoggedIn(authLoggedIn);
    };
    useEffect(() => {
        window.cb.core.iam.getEventBus().on('cb:core:iam:events:Login', () => {
            getIsLoggedIn();
        });
        window.cb.core.iam.getEventBus().on('cb:core:iam:events:Logout', () => {
            setIsLoggedIn(false);
        });
    }, []);
    useEffect(() => {
        getIsLoggedIn();
    }, [window.cb.core.iam]);
    return {
        isLoggedIn,
    };
};
//# sourceMappingURL=useLoginStatus.js.map